import type { Lang } from '~/types';

// utils/language.ts
import C from 'universal-cookie';

const cookies = new C();

const LANGUAGE_KEY = 'lang';

function setLanguage(lang: Lang) {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(LANGUAGE_KEY, lang);
  }
  cookies.set('lang', lang);
}

function getLanguage(): Lang {
  if (typeof window === 'undefined') {
    return 'HU'; // Or any default language you prefer for SSR
  }

  const lang = sessionStorage.getItem(LANGUAGE_KEY);

  if (lang === 'HU' || lang === 'RS' || lang === 'EN') {
    return lang as Lang;
  }
  else {
    // If no language is set, or it's an invalid value, set it to "HU"
    setLanguage('HU');
    return 'HU';
  }
}

// Call this function on application startup to ensure a default language is set
function initializeLanguage() {
  if (typeof window !== 'undefined' && !sessionStorage.getItem(LANGUAGE_KEY)) {
    setLanguage('HU');
  }
}

// A server-side alternative to get the language, possibly from headers or cookies
function getLanguageServerSide(requestHeaders: Headers): Lang {
  // Example: Attempt to get language from the "Accept-Language" header
  const acceptLanguage = requestHeaders.get('Accept-Language');
  if (acceptLanguage) {
    const preferredLanguage = acceptLanguage.split(',')[0].substring(0, 2); // e.g., "en" from "en-US"

    if (preferredLanguage === 'hu')
      return 'HU';
    if (preferredLanguage === 'rs')
      return 'RS';
    if (preferredLanguage === 'en')
      return 'EN';
  }

  // Fallback to default language if no suitable header is found
  return 'HU';
}

export { getLanguage, getLanguageServerSide, initializeLanguage, setLanguage };
